{
  "notifications": {
    "overline": "НАСТРОЙКИ",
    "title": "Уведомления",
    "titleHighlight": "Уведомления",
    "signInHint": "Войдите для управления настройками уведомлений.",
    "loading": "Загрузка настроек...",
    "loadError": "Не удалось загрузить настройки уведомлений.",
    "retry": "Повторить",
    "errorTitle": "Что-то пошло не так",
    "desktop": "Уведомления на рабочем столе",
    "desktopHint": "Получайте пуш-уведомления о напоминаниях и сообщениях",
    "blockedInBrowser": "ЗАБЛОКИРОВАНО В БРАУЗЕРЕ",
    "blockedHint": "Уведомления заблокированы. Откройте настройки браузера для разрешения.",
    "push": "Push-уведомления",
    "pushHint": "Получайте уведомления о сообщениях и напоминаниях на это устройство",
    "pushBlockedHint": "Уведомления отключены. Включите их в настройках устройства.",
    "blockedInSystem": "ОТКЛЮЧЕНО В НАСТРОЙКАХ",
    "notificationsOn": "УВЕДОМЛЕНИЯ ВКЛ.",
    "enableNotifications": "ВКЛЮЧИТЬ УВЕДОМЛЕНИЯ",
    "reminderTime": "Время напоминания",
    "reminderTimeHint": "За сколько до сессии вас уведомить?",
    "autoNotify": "Автоуведомления о подписках",
    "autoNotifyHint": "Автоматически создавать напоминания о мероприятиях от ваших мастеров.",
    "autoNotifyOn": "АВТОУВЕДОМЛЕНИЯ ВКЛ.",
    "autoNotifyOff": "АВТОУВЕДОМЛЕНИЯ ВЫКЛ.",
    "footerNote": "Эти настройки относятся к пуш-уведомлениям браузера. Убедитесь, что уведомления включены.",
    "offset30min": "30 мин",
    "offset1hour": "1 час",
    "offset1_5hours": "1,5 часа",
    "offset2hours": "2 часа",
    "catSectionTitle": "Уведомления",
    "catSectionHint": "Выберите, о чём сообщать. По умолчанию включено всё.",
    "catMessages": "Сообщения",
    "catMessagesHint": "Уведомления о новых сообщениях от друзей и пользователей платформы.",
    "catMasterEvents": "Новые события мастеров",
    "catMasterEventsHint": "Уведомления о создании новых онлайн- и офлайн-событий мастерами, на которых вы подписаны.",
    "catPracticeStart": "Запуск практики",
    "catPracticeStartHint": "Уведомления, когда подписанный мастер начинает практику или Live-сессию.",
    "catNewMedia": "Новые медиа и практики",
    "catNewMediaHint": "Уведомления при публикации нового контента мастером.",
    "catSystem": "Системные уведомления",
    "catSystemHint": "Важные уведомления о работе платформы, обновлениях и изменениях.",
    "catPostEngagement": "Комментарии и реакции",
    "catPostEngagementHint": "Когда к вашим публикациям оставляют комментарии и реакции.",
    "subscriptions": "ПОДПИСКИ",
    "unavailable": "Настройки недоступны",
    "nativeFooter": "Напоминания приходят как уведомления о ваших событиях и сессиях мастеров.",
    "catAgapellaProactive": "Агапелла пишет первой",
    "catAgapellaProactiveHint": "Приветствия при возвращении и напоминания от ИИ-компаньона. Выключите — Агапелла не начнёт разговор сама, но останется на связи, когда напишете вы. Уведомления платформы это не затронет. Итоги недели настраиваются отдельно.",
    "catAgapellaWeeklySummary": "Итоги недели",
    "catAgapellaWeeklySummaryHint": "Раз в неделю Агапелла пишет в свой чат короткий итог: какие были практики, сколько минут и что вы записали о себе. Записи, закрытые от ИИ, в итог не попадают. Работает, если вы дали согласие на обработку данных в ИИ-чате."
  },
  "masterProfile": {
    "badge": {
      "required": "Обязательно",
      "optional": "Необязательно"
    },
    "hints": {
      "name": "Имя, которое увидят пользователи в вашем профиле.",
      "experience": "Как давно вы практикуете выбранное направление? Укажите количество лет и ключевые области работы.",
      "education": "Учёба, курсы, сертификаты и школы — всё, что повлияло на ваш профессиональный путь.",
      "uniqueness": "Чем ваш подход отличается от других специалистов? Что делает именно вас уникальным для клиентов?",
      "philosophy": "Какие ценности лежат в основе вашей работы? Опишите свою миссию и мировоззрение."
    },
    "about": {
      "title": "О мастере",
      "name": "Имя",
      "namePlaceholder": "Ваше имя",
      "directions": "Направления / практики",
      "experience": "Опыт в практиках",
      "experiencePlaceholder": "Как давно вы практикуете выбранное направление?",
      "education": "Образование / сертификация",
      "educationPlaceholder": "Учёба, курсы, сертификаты, школы.",
      "uniqueness": "Уникальность подхода / методологии",
      "uniquenessPlaceholder": "Чем ваш подход отличается от других специалистов?",
      "philosophy": "Философия / свободное описание",
      "philosophyPlaceholder": "Какие ценности лежат в основе вашей работы?",
      "philosophyLabel": "Философия",
      "showMore": "Показать больше",
      "aboutMeTitle": "Обо мне",
      "directionsTitle": "Мои направления",
      "directionsEmpty": "Направления пока не указаны."
    },
    "manifesto": {
      "title": "Видео-визитка",
      "description": "Загрузите видео-манифест, которое будет отображаться в вашем профиле.",
      "emptyTitle": "Видео-визитка пока не загружена",
      "emptyHint": "Добавьте её в настройках — гости видят этот блок первым.",
      "uploaded": "Видео загружено",
      "replace": "Заменить",
      "upload": "Загрузить видео",
      "uploadHint": "MP4, до 500 МБ",
      "cover": "Обложка",
      "captureFrame": "Использовать текущий кадр",
      "captureHint": "Поставьте видео на паузу в нужный момент и выберите текущий кадр для обложки.",
      "captureHintNoVideo": "Сначала загрузите видео, затем выберите кадр для обложки.",
      "uploading": "Загрузка…",
      "uploadingPercent": "Загрузка {{percent}}%",
      "save": "Сохранить видео-визитку",
      "webOnly": "Загрузка видео доступна в веб-версии.",
      "playbackError": "Видео пока не удаётся показать здесь. Откройте его в новой вкладке.",
      "openInNewTab": "Открыть в новой вкладке"
    },
    "path": {
      "title": "Мой путь",
      "addStep": "Добавить этап",
      "description": "Расскажите о вашем профессиональном и личном пути.",
      "datePlaceholder": "2023-05",
      "eventPlaceholder": "Что произошло",
      "deleteStep": "Удалить этап пути"
    },
    "agape": {
      "title": "Что для меня Agape",
      "upload": "Загрузить видео",
      "description": "Видео-ответ на вопросы: что для меня Agape и как я понимаю философию Agape?",
      "uploaded": "Видео загружено",
      "replace": "Заменить",
      "delete": "Удалить",
      "uploading": "Загрузка…",
      "uploadingPercent": "Загрузка {{percent}}%",
      "save": "Сохранить видео",
      "webOnly": "Загрузка видео доступна в веб-версии."
    },
    "actions": {
      "cancel": "Отмена",
      "saveChanges": "Сохранить изменения",
      "savedOk": "Все изменения сохранены",
      "pathValidationError": "Заполните дату (ГГГГ-ММ) и описание для всех этапов пути",
      "requiredFieldsError": "Заполните обязательные поля: имя, хотя бы одно направление и хотя бы одно поле в разделе «О себе»."
    },
    "completion": {
      "title": "Заполненность профиля",
      "sections": {
        "photo": "Фото профиля",
        "about": "О мастере",
        "manifesto": "Видео-визитка",
        "directions": "Направления",
        "socials": "Социальные сети",
        "path": "Мой путь",
        "agape": "Что для меня Agape"
      },
      "addSocials": "Добавить соцсети →",
      "calculating": "Считаем…",
      "motivationDone": "Профиль заполнен",
      "motivationAlmost": "Почти готово!",
      "motivationGood": "Хороший прогресс!",
      "motivationStart": "Хорошее начало!",
      "motivationEmpty": "Заполните профиль"
    },
    "required": {
      "title": "Обязательные разделы",
      "subtitle": "Заполните все обязательные разделы для публикации профиля.",
      "aboutTitle": "О мастере",
      "fieldsCount": "{{filled}}/{{total}} полей заполнено",
      "manifestoTitle": "Видео-визитка",
      "manifestoAdded": "Видео добавлено",
      "manifestoMissing": "Загрузите видео-визитку",
      "directionsTitle": "Направления",
      "directionsSelected_one": "{{count}} направление выбрано",
      "directionsSelected_few": "{{count}} направления выбрано",
      "directionsSelected_many": "{{count}} направлений выбрано",
      "directionsSelected_other": "{{count}} направлений выбрано",
      "directionsMissing": "Добавьте минимум 1 направление"
    },
    "legend": {
      "title": "Легенда",
      "filled": "Раздел заполнен",
      "partial": "Раздел заполнен частично",
      "empty": "Раздел не заполнен",
      "optional": "Необязательный раздел",
      "hintTitle": "Подсказка",
      "hintText": "Нажмите на иконку рядом с полем, чтобы увидеть примеры и рекомендации по заполнению."
    },
    "socials": {
      "title": "Соцсети и ресурсы",
      "settingsTitle": "Контакты и соцсети",
      "filled": "Заполнено {{filled}} из {{total}}",
      "loading": "Загружаем ссылки…",
      "active": "Активно",
      "needsFix": "Проверьте",
      "edit": "Изменить",
      "add": "+ Добавить",
      "save": "Сохранить",
      "errors": {
        "notAUrl": "Введите корректную ссылку на {{platform}}",
        "notAUrlWebsite": "Введите корректный адрес сайта",
        "wrongPlatform": "Ссылка должна вести на {{platform}}",
        "placeholderHost": "Это адрес из примера — впишите свой",
        "serviceRoot": "Нужен адрес профиля, а не главная страница {{platform}}",
        "tooLong": "Ссылка слишком длинная"
      },
      "saveError": "Ссылка не сохранилась. Попробуйте ещё раз.",
      "willSave": "Сохраним как {{url}}",
      "willClear": "Поле пустое — ссылка удалится",
      "platforms": {
        "website": "Сайт",
        "instagram": "Instagram",
        "youtube": "YouTube",
        "telegram": "Telegram",
        "rutube": "RuTube",
        "dzen": "Дзен",
        "vk": "ВКонтакте"
      }
    },
    "account": {
      "title": "Аккаунт",
      "notifications": "Push и напоминания",
      "notificationsDesc": "Разрешение браузера и время напоминаний о событиях",
      "library": "Избранное",
      "libraryDesc": "Избранные практики и материалы",
      "theme": "Тема",
      "themeDesc": "Оформление интерфейса",
      "themeDark": "Тёмная",
      "themeLight": "Светлая",
      "themeSystem": "Системная",
      "security": "Безопасность входа",
      "securityDesc": "Passkey и пароль",
      "logout": "Выйти из аккаунта"
    },
    "editors": {
      "section": "ПРОФИЛЬ МАСТЕРА",
      "profile": "Настройка профиля",
      "profileHint": "Фото, обложка, имя, город",
      "aboutHint": "Опыт, образование, философия",
      "directionsHint": "Чем вы занимаетесь",
      "pathHint": "Этапы и события",
      "done": "Готово",
      "hintA11y": "Подсказка к полю «{{label}}»",
      "cover": "Обложка",
      "photo": "Фото профиля",
      "location": "Город / страна",
      "locationPlaceholder": "Например, Москва",
      "directionsNote": "Выберите направления, в которых вы работаете.",
      "pathNote": "Этапы пути: дата (ГГГГ-ММ) и описание.",
      "dateFormat": "ГГГГ-ММ",
      "saveFailed": "Не удалось сохранить",
      "socialsNote": "Ссылки на ваши профили — они появятся в публичном профиле мастера.",
      "aboutEmpty": "Профиль ещё не заполнен — добавьте описание в настройках."
    },
    "visibility": {
      "title": "Видимость профиля",
      "visible": "Профиль виден всем",
      "visibleDesc": "Вас находят в каталоге мастеров, по прямой ссылке и в рекомендациях Агапеллы.",
      "hiddenByOwner": "Профиль скрыт",
      "hiddenByOwnerDesc": "Другие люди не видят профиль в каталоге и по прямой ссылке. Вы можете по-прежнему его редактировать — правки не откроют его без вашего решения.",
      "hiddenByAdmin": "Профиль скрыт платформой",
      "hiddenByAdminDesc": "Вернуть видимость отсюда нельзя — это может сделать только команда Агапеллы.",
      "notPublished": "Профиль не опубликован",
      "notPublishedDesc": "Публичной версии профиля сейчас нет, поэтому скрывать нечего.",
      "keeps": "Скрытие не удаляет аккаунт. Практики, записи, Live-сессии, подписки, покупки и чаты сохраняются, начатые диалоги продолжают работать.",
      "hide": "Скрыть профиль",
      "unhide": "Вернуть профиль",
      "confirmTitle": "Скрыть профиль?",
      "confirmBody": "Профиль, ваши практики и Live-сессии перестанут показываться другим людям. Вернуть видимость можно здесь же в любой момент.",
      "confirm": "Скрыть",
      "cancel": "Отмена",
      "errors": {
        "nothingToHide": "Скрывать пока нечего: у профиля нет опубликованной версии.",
        "hiddenByAdmin": "Профиль скрыт платформой, вернуть его отсюда нельзя.",
        "noProfile": "Профиль мастера не найден.",
        "generic": "Не получилось сохранить. Проверьте соединение и попробуйте ещё раз."
      },
      "bannerOwner": "Профиль скрыт — его не видят в каталоге и по ссылке.",
      "bannerAdmin": "Профиль скрыт платформой и не виден другим людям.",
      "bannerAction": "Настройки видимости"
    }
  },
  "app": {
    "title": "Настройки",
    "language": {
      "title": "Язык",
      "hint": "Язык интерфейса приложения"
    },
    "account": {
      "section": "АККАУНТ",
      "email": "EMAIL",
      "notifications": "Уведомления",
      "notificationsHint": "Push и напоминания о событиях",
      "socials": "Соцсети",
      "socialsHint": "Ссылки на ваши профили",
      "library": "Моя библиотека",
      "libraryHint": "Сохранённые практики и плейлисты"
    },
    "privacy": {
      "section": "ПРИВАТНОСТЬ",
      "calendar": "Календарь событий",
      "calendarHint": "Кто видит, на какие события вы идёте",
      "feed": "Практики в ленте",
      "feedHint": "Кто видит практики, добавленные в ленту",
      "all": "Все",
      "subscribers": "Подписчики",
      "onlyMe": "Только я"
    },
    "assistant": {
      "section": "АГАПЕЛЛА",
      "proactive": "Проактивные сообщения",
      "proactiveHint": "Как часто Агапелла пишет первой",
      "normal": "Обычно",
      "reduced": "Реже",
      "off": "Не писать",
      "aiData": "Данные и ИИ",
      "consentGranted": "Согласие на передачу сообщений ИИ-сервису дано",
      "consentMissing": "Согласие не дано — чат с ИИ-помощницей закрыт",
      "eraseTitle": "Удалить данные ИИ-чата?",
      "eraseBody": "Будут удалены долговременная память, собранный профиль и сама переписка с помощницей: то, что вы рассказывали о себе, придётся рассказать заново. Это нельзя отменить.",
      "eraseCancel": "Отмена",
      "eraseConfirm": "Удалить",
      "eraseDoneTitle": "Готово",
      "eraseDoneBody": "Память, профиль и переписка с помощницей удалены.",
      "erasePartialTitle": "Удалено не всё",
      "erasePartialBody": "Удалено то, что хранится на основном сервере. Переписка, долговременная память помощницы и собранный ею профиль лежат в сервисе чата — он сейчас недоступен, и их удалить не удалось. Попробуйте ещё раз позже.",
      "eraseFailTitle": "Не получилось",
      "eraseFailBody": "Не удалось удалить данные. Проверьте соединение и попробуйте ещё раз или напишите на info@agapella.io.",
      "revokeTitle": "Отозвать согласие?",
      "revokeBody": "Чат с ИИ-помощницей закроется, а всё, что уже накоплено, будет удалено: долговременная память, собранный профиль и переписка. Это нельзя отменить.",
      "revokeConfirm": "Отозвать и удалить",
      "memoryChatNote": "Здесь — заметки, которые помощница сохранила о тебе. Долговременную память разговоров этот экран пока не показывает; стереть её целиком можно в Настройках, пункт «Данные и ИИ»."
    },
    "security": {
      "section": "АККАУНТ И БЕЗОПАСНОСТЬ",
      "blocked": "Чёрный список",
      "blockedNone": "Никто не заблокирован",
      "blockedCount_one": "{{count}} человек",
      "blockedCount_few": "{{count}} человека",
      "blockedCount_many": "{{count}} человек",
      "blockedCount_other": "{{count}} человек"
    },
    "legal": {
      "section": "ПРАВОВАЯ ИНФОРМАЦИЯ",
      "terms": "Пользовательское соглашение",
      "termsHint": "Правила платформы и правила поведения",
      "privacy": "Политика конфиденциальности",
      "privacyHint": "Как мы обрабатываем ваши данные"
    },
    "marketing": {
      "title": "Рекламные сообщения",
      "grantedHint": "Вы согласились получать рекламные сообщения. Нажмите, чтобы отозвать согласие",
      "deniedHint": "Рекламные сообщения вам не отправляются. Нажмите, чтобы разрешить",
      "on": "Разрешены",
      "off": "Запрещены",
      "errorRejected": "Сейчас это согласие оформить нельзя: сервер его не принял. Если вопрос остался — напишите в поддержку.",
      "errorFailed": "Не получилось сохранить выбор. Проверьте соединение и попробуйте ещё раз."
    }
  },
  "securityScreen": {
    "passwordSection": "ПАРОЛЬ",
    "changePassword": "Изменить пароль",
    "setPassword": "Установить пароль",
    "changeHint": "Мы отправим ссылку на {{email}} — по ней можно сменить пароль.",
    "setHint": "Мы отправим ссылку на {{email}} — по ней можно задать пароль.",
    "yourEmail": "вашу почту",
    "sent": "Письмо отправлено. Проверьте почту {{email}}.",
    "sendFailed": "Не удалось отправить письмо",
    "passkeySection": "УСТРОЙСТВА И PASSKEY",
    "passkeyTitle": "Вход по passkey",
    "passkeyHint": "Беспарольный вход по passkey пока доступен в веб-версии. На телефоне добавим позже."
  }
}
